import React, { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";

export default function Nav() {
  const { toggleTheme } = useTheme();
  const [scrolled, setscrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setscrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="nav" data-scrolled={scrolled ? "" : undefined}>
      <a href="#top" className="nav-logo">
        jpg<b>·</b>guimalan
      </a>
      <div className="nav-links mono">
        <a href="#about">about</a>
        <a href="#work">work</a>
        <a href="#projects">projects</a>
        <a href="#updates">updates</a>
        <a href="#writing">writing</a>
        <a href="#contact">contact</a>
      </div>
      <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
        <span className="tt-track">
          <span className="tt-knob" />
        </span>
      </button>
    </nav>
  );
}
